import { createContext } from "react";

const DF_OT0070Context = createContext();

export { DF_OT0070Context };
